import { StepName } from '../types';

const isFinancingActive = (activeStep?: StepName) =>
  activeStep === 'financingConnectedPolicy' ||
  activeStep === 'financingCostAndResources' ||
  activeStep === 'financingLoan';

export default isFinancingActive;
